import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

export const StyledOption = styled.li`
  padding: ${({ theme }) => theme.gutterSmall} ${({ theme }) => theme.gutter};
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.themeColorLight};
  }

  ${(props) => props.active && `
    background: ${props.theme.themeColorPrimary};
    color: ${props.theme.themeColorWhite};
  `}

  &:last-child {
    border-bottom-left-radius: ${({ theme }) => theme.borderRadius};
    border-bottom-right-radius: ${({ theme }) => theme.borderRadius};
  }
`

const Option = ({ label, active, onChange }) => (
  <StyledOption onClick={onChange}>{label}</StyledOption>
)

export default Option

Option.propTypes = {
  label: PropTypes.string.isRequired,
  active: PropTypes.bool
}

Option.defaultProps = {
  active: false
}